<template>
  <div class="profile-table-wrap">
    <div class="table-topbar">
      <p class="table-kicker">Listado de perfiles por usuario</p>
      <div class="input-group search-box">
        <span class="input-group-text"><i class="bi bi-search"></i></span>
        <input type="text" class="form-control" placeholder="Buscar usuario o perfil..." v-model="searchQuery" @input="Filtro">
        <button v-if="searchQuery" class="btn btn-outline-secondary" type="button" @click="limpiarBusqueda"><i class="bi bi-x-lg"></i></button>
      </div>
    </div>

    <div class="table-responsive">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status"></div>
        <p class="mt-2 text-secondary">Cargando información...</p>
      </div>

      <table v-else class="table table-bordered table-hover qh-admin-table mt-0">
        <thead class="reducirTamaño">
          <tr class="text-nowrap text-center">
            <th class="sortable-th" @click="sortBy('idUsuario')" role="button" tabindex="0" @keydown.enter="sortBy('idUsuario')">ID<i class="bi ms-1" :class="sortIcon('idUsuario')"></i></th>
            <th class="sortable-th" @click="sortBy('nomUsuario')" role="button" tabindex="0" @keydown.enter="sortBy('nomUsuario')">APELLIDOS Y NOMBRES<i class="bi ms-1" :class="sortIcon('nomUsuario')"></i></th>
            <th class="sortable-th" @click="sortBy('perNombre')" role="button" tabindex="0" @keydown.enter="sortBy('perNombre')">PERFIL<i class="bi ms-1" :class="sortIcon('perNombre')"></i></th>
            <th class="sortable-th" @click="sortBy('audfecCreacion')" role="button" tabindex="0" @keydown.enter="sortBy('audfecCreacion')">CREACIÓN<i class="bi ms-1" :class="sortIcon('audfecCreacion')"></i></th>
            <th class="sortable-th" @click="sortBy('audfecActualizacion')" role="button" tabindex="0" @keydown.enter="sortBy('audfecActualizacion')">ACTUALIZACIÓN<i class="bi ms-1" :class="sortIcon('audfecActualizacion')"></i></th>
            <th><i class="bi bi-boxes fs-5"></i></th>
          </tr>
        </thead>

        <tbody class="text-nowrap text-center texto-fini align-middle">
          <tr v-if="!paginatedLista.length">
            <td colspan="6" class="table-state-cell">
              <div class="state-block empty">
                <i class="bi bi-people fs-1 text-secondary"></i>
                <div class="mt-2 fw-semibold">No se encontraron perfiles asignados</div>
                <small class="text-muted">Prueba con otro texto de búsqueda.</small>
              </div>
            </td>
          </tr>

          <tr class="reducirTamaño" v-for="lista in paginatedLista" :key="`${lista.idUsuario}-${lista.idPerfil}`">
            <td>{{ lista.idUsuario }}</td>
            <td class="text-start">{{ lista.nomUsuario }}</td>
            <td class="text-center">{{ lista.perNombre }}</td>
            <td>{{ lista.audfechaCreacion }}</td>
            <td>{{ lista.audfechaActualizacion }}</td>
            <td class="py-1">
              <div class="action-group">
                <button @click="openEditModal(lista.idPerfil, lista.perNombre, lista)" class="btn btn-warning action-pill" title="Editar asignación">
                  <i class="bi bi-pencil text-white fs-5"></i>
                </button>
                <button @click="eliminarAsignacion(lista)" class="btn btn-light text-danger action-pill" title="Eliminar asignación">
                  <i class="bi bi-trash3 fs-5"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="!loading" class="table-footer-bar">
      <div class="page-size-control"><label>Mostrar</label><select v-model.number="itemsPerPage" @change="onPageSizeChange" class="form-select form-select-sm"><option v-for="size in pageSizeOptions" :key="size" :value="size">{{ size }}</option></select><span>registros</span></div>
      <div class="record-count">{{ totalRows }} resultado(s)</div>
    </div>

    <div v-if="!loading" class="pagination-container d-flex justify-content-center align-items-center gap-2 my-2">
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1"><i class="bi bi-chevron-double-left"></i></button>
      <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1"><i class="bi bi-chevron-left"></i></button>
      <span class="pagination-info small">Página {{ currentPage }} de {{ totalPages || 1 }}</span>
      <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages || totalPages === 0"><i class="bi bi-chevron-right"></i></button>
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages" :disabled="currentPage === totalPages || totalPages === 0"><i class="bi bi-chevron-double-right"></i></button>
    </div>

    <b-modal ref="editModal" centered title="Editar acceso" hide-footer hide-close-button>
      <div class="mt-2">
        <label class="form-label fw-semibold">Seleccionar perfil</label>
        <select class="form-select mt-2" v-model="idPerfil">
          <option disabled value="">Seleccionar perfil</option>
          <option v-for="item in ListaPerfil" :key="item.idPerfil" :value="item.idPerfil">{{ item.perNombre }}</option>
        </select>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-3">
        <b-button variant="primary" @click="saveChanges"><i class="bi bi-check-circle me-1"></i> Guardar</b-button>
        <b-button variant="secondary" @click="closeEditModal"><i class="bi bi-x-lg me-1"></i> Cerrar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import tableUx from "@/mixins/tableUx";
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert";
import Swal2 from "sweetalert2";
export default {
  mixins: [tableUx],
  name: "PowerbyTablaUsuario",
  data() {
    return {
      itemsPerPage: 10,
      currentPage: 1,
      idPerfil: "",
      nombrePerfil: "",
      idUsuario: "",
      idUsuarioUnico: "",
      searchQuery: "",
      loading: false
    };
  },
  mounted() {
    this.idUsuario = localStorage.getItem("userId");
  },
  computed: {
    ...mapGetters("acciones", ["ListaPerfil", "ListaPerfilxUsuario"]),
    listaFiltrada() {
      if (!this.searchQuery) return this.ListaPerfilxUsuario;
      return this.ListaPerfilxUsuario.filter(
        (item) =>
          item.nomUsuario.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          item.perNombre.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    totalRows() { return this.listaFiltrada.length; },
    totalPages() { return Math.ceil(this.listaFiltrada.length / this.itemsPerPage); },
    paginatedLista() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.sortedRows(this.listaFiltrada).slice(start, start + this.itemsPerPage);
    }
  },
  methods: {
    ...mapActions("acciones", ["ListarPerfilxUsuario"]),
    limpiarBusqueda() { this.searchQuery = ""; this.currentPage = 1; },
    async eliminarAsignacion(asignacion) {
      const confirmacion = await Swal2.fire({
        icon: "warning",
        title: "¿Eliminar asignación?",
        text: `Se quitará el perfil "${asignacion.perNombre}" al usuario "${asignacion.nomUsuario}".`,
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#dc3545",
      });
      if (!confirmacion.isConfirmed) return;

      try {
        const idUsuario = encodeURIComponent(asignacion.idUsuario);
        const idPerfil = encodeURIComponent(asignacion.idPerfil);
        await this.axios.delete(
          `BIClientes/EliminarAcceso?idUsuario=${idUsuario}&idPerfil=${idPerfil}`
        );
        await this.ListarPerfilxUsuario();
        Swal2.fire("Asignación eliminada", "El perfil fue retirado del usuario.", "success");
      } catch (error) {
        const mensaje =
          error.response?.data?.mensaje ||
          error.response?.data?.message ||
          "No se pudo eliminar la asignación seleccionada.";
        Swal2.fire("No se pudo eliminar", mensaje, "error");
      }
    },
    openEditModal(idPerfil, nombre, id) {
      this.idPerfil = idPerfil;
      this.nombrePerfil = nombre;
      this.idUsuarioUnico = id.idUsuario;
      this.$refs.editModal.show();
    },
    closeEditModal() {
      this.idPerfil = "";
      this.nombrePerfil = "";
      this.$refs.editModal.hide();
    },
    saveChanges() {
      const from = {
        idUsuario: this.idUsuarioUnico,
        idPerfil: this.idPerfil,
        idUsuCreacion: this.idUsuario,
      };
      this.axios.put(`BIClientes/ModificarAcceso`, from).then((r) => {
        if (r.data) {
          Swal(`Se realizaron los cambios`, "", "success");
          this.ListarPerfilxUsuario();
          this.closeEditModal();
        }
      });
    },
    Filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 300);
    },
  },
};
</script>

<style scoped>
.b-modal .modal-header button.close { display: none; }
.profile-table-wrap { display: grid; gap: .85rem; }
.table-topbar { display: flex; justify-content: space-between; align-items: center; gap: 1rem; flex-wrap: wrap; }
.table-kicker { margin: 0; color: #5f6f84; font-size: 1rem; }
.search-box { max-width: 400px; }
.search-box .form-control, .search-box .input-group-text, .search-box .btn { min-height: 52px; }
.qh-admin-table thead tr { background: #eef4fb; color: #234267; }
.action-group { display: inline-flex; align-items: center; gap: .45rem; }
.action-pill { border-radius: 12px; padding: .35rem .8rem; }
.reducirTamaño { font-size: .72rem; }
.table-state-cell { height: 220px; }
.state-block { min-height: 220px; display: flex; flex-direction: column; align-items: center; justify-content: center; }
@media (max-width: 767.98px) {
  .table-topbar { align-items: stretch; }
  .search-box { max-width: 100%; width: 100%; }
}
</style>
